import { ReactNode } from "react";
import './modal.css'

export default function Modal(props:{children: ReactNode, on_click_background?: ()=>void}){
    return  <div 
        className="modal" 
        role="dialog"
        aria-atomic
    >
        <div onClick={()=>{if(props.on_click_background){
            props.on_click_background();
        }}} 
        className="modal__background"
        aria-hidden
        ></div>
        {props.children}
    </div>;  
}    